import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from "js-cookie";
import { toggleCollapsedNav } from '../redux/action/Theme';
import requester from "../library/Requester"; 
import * as util from '../library/utilitys';

class PreparePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tmplink: Cookies.get("tmplink") ? JSON.parse(Cookies.get("tmplink")) : null,
            error: null,
        };
        this.apiCalled = false; // ref-like flag
    }

    componentDidMount() {
        if (!this.apiCalled) {
            this.apiCalled = true;
            this.checkUserProfile();
        }
    }

    checkUserProfile = () => {
        const { tmplink } = this.state;

        if (!tmplink) {
            // window.location.href = "/back-office";
            return;
        }

        requester.post("/login/ms", { tmplink })
        .then((response) => {
            const { token, user, permission } = response.data;

            if (token || user || permission) {
                Cookies.remove("sidebarPermit");
                Cookies.remove("userProfile");
                Cookies.remove("tmplink");

                
                const cookieOptions = {
                    expires: process.env.REACT_APP_COOKIE_AGE 
                        ? Number(process.env.REACT_APP_COOKIE_AGE) 
                        : 7, // ถ้าไม่ตั้งใน .env ให้ default = 7 วัน
                    secure: process.env.REACT_APP_ENV_MODE === "production", // prod = true, dev = false
                    sameSite: "Lax"
                };

                Cookies.set("userProfile", JSON.stringify(user), cookieOptions);
                Cookies.set("sidebarPermit", JSON.stringify(permission), cookieOptions);

                localStorage.setItem("authToken", token);
                window.location.href = "/apps/dashboard"; 
            } else {
                alert("ไม่สามารถตรวจสอบผู้ใช้ได้");
            }
        })
        .catch((err) => {
            console.error("Prepare check error:", err);
            // this.setState({ error: "เกิดข้อผิดพลาดในการตรวจสอบผู้ใช้" });
            alert("เกิดข้อผิดพลาดในการตรวจสอบผู้ใช้");
            // window.location.href = "/back-office"; 
        });

    }

    render() {
        const { error } = this.state;
        return (
            <div className="vh-100 d-flex justify-content-center align-items-center">
                {error ? (
                    <div style={{ color: 'red', fontSize: 16 }}>{error}</div>
                ) : (
                    <div>กำลังตรวจสอบข้อมูลผู้ใช้...</div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
}

export default connect(mapStateToProps, { toggleCollapsedNav })(PreparePage);
